import jwtDecode from 'jwt-decode'
import store from 'store2'
import injector from 'vue-inject'
import authType from '../types/auth'
import modulesType from '../types/modules'

const state = {
  status: '😶',
  user: {
    id: null,
    iat: null,
    username: null,
    role: null,
    provinces: [],
  },
  token: null,
  logged: store.has('TID'),
}

const getters = {
  [authType.getters.getUser](state) {
    return state.user
  },
  [authType.getters.getToken](state) {
    return state.token
  },
}

const mutations = {
  [authType.mutations.signInRequest](state) {
    state.status = '⏳'
  },
  [authType.mutations.signInSuccess](state, { user, token }) {
    state.status = '😃'
    state.user.id = user.id
    state.user.iat = user.iat
    state.user.username = user.username
    state.user.role = user.role
    state.user.provinces = user.provinces || []
    state.token = token
    state.logged = true
  },
  [authType.mutations.signInFailure](state) {
    state.status = '😵'
  },
  [authType.mutations.logout](state) {
    state.status = '😶'
    state.user.id = null
    state.user.iat = null
    state.user.username = null
    state.user.role = null
    state.user.provinces = []
    state.token = null
    state.logged = false
  },
}

const actions = {
  [authType.actions.setUser]: injector.encase(['axios'], (axios) => async ({ commit }) => {
    if (store.has('TID')) {
      const token = store.get('TID')
      const user = jwtDecode(token)
      commit(authType.mutations.signInSuccess, { user, token })
      axios.defaults.headers.common.Authorization = `Bearer ${token}`
    }
  }),
  [authType.actions.signIn]: injector.encase(['AuthService', 'UserService'], (AuthService, UserService) => async ({ dispatch, commit }, credentials) => {
    try {
      commit(authType.mutations.signInRequest)
      const token = await AuthService.signIn(credentials)
      if (typeof token !== 'string') {
        throw token
      }
      const user = jwtDecode(token)
      const roles = await UserService.roles(user.id)
      const modules = await UserService.modules(user.id)
      user.role = roles.join(', ')
      await dispatch(modulesType.actions.setModules, { modules })
      commit(authType.mutations.signInSuccess, { user, token })
      return true
    } catch (error) {
      // console.log(error.message, 'error.message vuex')
      commit(authType.mutations.signInFailure)
      throw error
    }
  }),
  // [authType.actions.cambiarClave]: injector.encase(['AuthService'], (AuthService, UserService) => async ({ dispatch, commit }, credentials) => {
  //   try {
  //     commit(authType.mutations.signInRequest)
  //     const token = await AuthService.cambiarClave(credentials)
  //     if (typeof token !== 'string') {
  //       throw token
  //     }
  //     const user = jwtDecode(token)
  //     const roles = await UserService.roles(user.id)
  //     const modules = await UserService.modules(user.id)
  //     user.role = roles.join(', ')
  //     await dispatch(modulesType.actions.setModules, { modules })
  //     commit(authType.mutations.signInSuccess, { user, token })
  //     return true
  //   } catch (error) {
  //     console.log(error.message, 'error.message vuex')
  //     commit(authType.mutations.signInFailure)
  //     throw error
  //   }
  // }),
  [authType.actions.logout]: injector.encase(['AuthService'], (AuthService) => async ({ commit }) => {
    await AuthService.logout()
    store.remove('TID')
    commit(authType.mutations.logout)
  }),
}

export default {
  state,
  getters,
  mutations,
  actions,
}
